import { writable } from 'svelte/store';
export const sendMessageWritable = writable();
